import { ReactElement } from "react";

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4-mini";

import { Queries } from "@/queries/Queries.ts";
import { CenteredLoader } from "@/uiKit/atoms/Loader.tsx";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";
import type { PatientListMenuItems } from "@/uiKit/organisms/PatientsList/PatientListMenu.tsx";
import { PatientListForDoctorsPage } from "@/uiKit/pages/PatientsListForDoctorsPage.tsx";
import { PatientListForNursesPage } from "@/uiKit/pages/PatientsListForNursesPage.tsx";
import { cz, Schema } from "@/utils/zodUtils.ts";

type SearchOptions = {
  menu?: PatientListMenuItems;
  search?: string;
};

const searchOptionsSchema: Schema<SearchOptions> = z.object({
  menu: cz.optional(z.literal(["monitored", "all", "pregnant"])),
  search: cz.optional(z.string()),
});

export const Route = createFileRoute("/_practitioner/patients/")({
  component: PageSwitch,
  validateSearch: (search): SearchOptions => searchOptionsSchema.parse(search),
  wrapInSuspense: true,
  pendingComponent: CenteredLoader,
  errorComponent: HandledErrorCard,
});

function PageSwitch(): ReactElement {
  const me = Queries.user.usePractitionerMe({});

  switch (me.qualification) {
    case "nurse":
      return <PatientListForNursesPage />;
    case "doctor":
      return <PatientListForDoctorsPage />;
    default:
      return <HandledErrorCard error={new Error("Unknown practitioner qualification")} reset={() => {}} />;
  }
}
